/**
 * Siffran på appikonen (Badging API).
 *
 * Två håll skriver badgen och de måste hållas i synk:
 * - service workern vid push, så siffran stämmer när appen är stängd
 *   (public/service-worker.js → applyBadge)
 * - appen när notiserna läses, vilket är den här filen
 *
 * Utan det andra hållet hade badgen bara vuxit: att öppna appen och läsa
 * klockan hade lämnat kvar siffran tills nästa push.
 *
 * Stödet är omvänt mot notisknapparna — iOS 16.4+ har badging för appar på
 * hemskärmen, Chrome på Android saknar det. Därför feature-check i stället för
 * plattformsgissning.
 */

/**
 * Sätter badgen till ett antal, eller tar bort den när antalet är 0.
 *
 * @param {number} count - Antal olästa. 0 eller mindre tar bort badgen.
 * @returns {void} Fel sväljs; badgen är dekoration och får inte krascha UI:t.
 */
export function setAppBadgeCount(count) {
  if (typeof navigator === 'undefined') return;
  try {
    if (count > 0) {
      if ('setAppBadge' in navigator) navigator.setAppBadge(count);
    } else if ('clearAppBadge' in navigator) {
      navigator.clearAppBadge();
    }
  } catch (e) {
    // Vissa webbläsare kastar när sidan inte körs installerad. Att inte kunna
    // visa en siffra på ikonen är inget att avbryta för.
  }
}
